import StringHelpers from "../../utilities/stringHelpers"
import {minutesToUnit, toDateTimeString} from "../../utilities/dateUtilities"
import Enums from "../../utilities/enum"
import stringHelpers from "../../utilities/stringHelpers";
import arrayUtilities from "../../utilities/arrayUtilities";

export const AnprSettingDisplay = ({anprSetting, validityDays, isStandardAnpr, allContraventions}) => {

    const noSpecificValidityTimes = !isStandardAnpr && (StringHelpers.isNullOrEmpty(anprSetting.enabledFromTime) || StringHelpers.isNullOrEmpty(anprSetting.enabledToTime))
    const showContraventionSettings = isStandardAnpr || !anprSetting.isNonEnforcement

    const getContraventionDisplayDetails = (id) => {
        if (!arrayUtilities.isNullOrEmpty(allContraventions)) {
            const contravention = allContraventions.find(item => item.id === id);
            if (contravention !== undefined) {
                return `${contravention.name} (${Enums.ContraventionTypes[contravention.contraventionType]})`
            }
        }
        return null
    }
    return (<div className="card-body bg-light border-top details-container">
            <div className="row">
                <div className="col-md-4 col-12  ">
                    <p className="font-weight-semi-bold mb-3">Name</p>
                </div>
                <div className="col-md-6 col-12 "><p className="mb-0">{anprSetting.name}</p></div>
            </div>
            <div className="row">
                <div className="col-md-4 col-12 ">
                    <p className="font-weight-semi-bold  mb-3">Enabled</p>
                </div>
                <div className="col-md-6 col-12 pt-1">{anprSetting.isEnabled &&
                    <i className="fas fa-check text-success"></i>}{!anprSetting.isEnabled &&
                    <i className="fas fa-times text-danger"></i>}</div>
            </div>

            {!isStandardAnpr && <div className="row mb-2">
                <div className=" col-md-4 col-12 ">
                    <p className="font-weight-semi-bold m-0">Suspend Enforcement</p>
                </div>
                <div className="col-md-6 col-12 pt-1">{anprSetting.isNonEnforcement &&
                    <i className="fas fa-check text-success"></i>}{!anprSetting.isNonEnforcement &&
                    <i className="fas fa-times text-danger"></i>}</div>
            </div>}
            {
                showContraventionSettings
                && <>
                    <div className="row mb-1">
                        <div className="col-md-4 col-12 ">
                            <p className="font-weight-semi-bold  mt-1 mb-1">Consideration Period
                                (mins)</p>
                            <p className="text-secondary fs--2">Maximum length of stay between entry
                                and exit that does not result in a parking charge.</p>
                        </div>
                        <div className="col-md-4 col-12  pt-1">
                            <p className="m-0">{anprSetting.considerationPeriodMinutes}</p>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-4 col-12">
                            <p className="font-weight-semi-bold m-0">Allow List Entry Grace</p>
                            <p className="text-secondary fs--2">Following entry, vehicles on allow list must be either added
                                via
                                portal or make a payment within this time to avoid a breach.</p>
                        </div>
                        <div className=" col-md-6 col-12">
                            <div>
                        <span>
                                    {StringHelpers.formatDecimal(minutesToUnit(anprSetting.allowListEntryGraceMinutes).value, 0)}
                            <span className="ml-1">
                                        {StringHelpers.pluralSuffixModifier(minutesToUnit(anprSetting.allowListEntryGraceMinutes).value, Enums.TimeSpanMode[minutesToUnit(anprSetting.allowListEntryGraceMinutes).unit])}
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-4 col-12">
                            <p className="font-weight-semi-bold m-0">Allow List Exit Grace</p>
                            <p className="text-secondary fs--2">Following payment expiry or portal permit expiry, vehicles
                                on
                                allow list must exit within this time to avoid a breach.</p>
                        </div>
                        <div className=" col-md-6 col-12 ">
                    <span>
                                    {StringHelpers.formatDecimal(minutesToUnit(anprSetting.allowListExitGraceMinutes).value, 0)}
                        <span className="ml-1">
                                        {StringHelpers.pluralSuffixModifier(minutesToUnit(anprSetting.allowListExitGraceMinutes).value, Enums.TimeSpanMode[minutesToUnit(anprSetting.allowListExitGraceMinutes).unit])}
                                    </span>
                                </span>
                        </div>
                    </div>

                    <div className="row mb-4">
                        <div className="col-md-4 col-12">
                            <p className="font-weight-semi-bold m-0">Allow List Duration Grace</p>
                        </div>
                        <div className=" col-md-6 col-12">
                    <span>
                                    {StringHelpers.formatDecimal(minutesToUnit(anprSetting.allowListDurationGraceMinutes).value, 0)}
                        <span className="ml-1">
                                        {StringHelpers.pluralSuffixModifier(minutesToUnit(anprSetting.allowListDurationGraceMinutes).value, Enums.TimeSpanMode[minutesToUnit(anprSetting.allowListDurationGraceMinutes).unit])}
                                    </span>
                                </span>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-4 col-12">
                            <p className="font-weight-semi-bold m-0">Parking Session Limit (mins)</p>
                            <p className="text-secondary fs--2">Limits the duration of a parking session - no breaches will
                                be
                                created for any sessions exceeding this limit.</p>
                        </div>
                        <div className=" col-md-6 col-12 ">
                            {StringHelpers.formatDecimal(anprSetting.enforcementLimitMinutes, 0)}
                        </div>
                    </div>
                    <div className="row">
                        <div className=" col-md-4 col-12 ">
                            <p className="font-weight-semi-bold m-0">Maximum Stay (mins)</p>
                            <p className="text-secondary fs--2">Applicable for maximum-stay sites.</p>
                        </div>
                        <div className=" col-md-6 col-12 ">
                            <div>{StringHelpers.formatDecimal(anprSetting.maxAllowedParkingDurationMinutes, 0)}</div>
                        </div>
                    </div>
                    <hr className="border-dashed border-bottom-0"></hr>
                    <div className="row mb-2">
                        <div className="col-md-4 col-12">
                            <h5 className="font-weight-semi-bold text-left">Over Stay Contravention</h5>
                        </div>
                    </div>
                    <div className="row align-items-center mb-1">
                        <div className="col-md-4 col-12">
                            <p className="font-weight-semi-bold m-0">Enabled</p>
                        </div>
                        <div className="col-md-6 col-12 ">
                            <i className={`fas ${!StringHelpers.isNullOrEmpty(anprSetting.overstayContraventionId) ? "fa-check text-success" : "fa-times text-danger"}`}></i>
                        </div>
                    </div>
                    {!StringHelpers.isNullOrEmpty(anprSetting.overstayContraventionId) && <div className="row">
                        <div className="col-md-4 col-12">
                            <p className="font-weight-semi-bold m-0">Contravention</p>
                        </div>
                        <div className="col-md-6 col-12 ">
                            <div>{!StringHelpers.isNullOrEmpty(anprSetting.overstayContraventionId) && getContraventionDisplayDetails(anprSetting.overstayContraventionId)}</div>
                        </div>
                    </div>}

                    {isStandardAnpr && <>
                        <hr className="border-dashed border-bottom-0"></hr>
                        <div className="row mb-1">
                            <div className="col-md-4 col-12">
                                <h5 className="font-weight-semi-bold text-left">Not On Allow List Contravention</h5>
                            </div>
                        </div>
                        <div className="row align-items-center mb-1">
                            <div className="col-md-4 col-12">
                                <p className="font-weight-semi-bold m-0">Enabled</p>
                            </div>
                            <div className=" col-md-6 col-12 grid-two-col">
                                <i className={`fas ${!StringHelpers.isNullOrEmpty(anprSetting.notOnAllowListContraventionId) ? "fa-check text-success" : "fas fa-times text-danger"}`}></i>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4 col-12">
                                <p className="font-weight-semi-bold m-0">Contravention</p>
                            </div>
                            <div className="col-md-6 col-12 grid-two-col">
                                <div>{!StringHelpers.isNullOrEmpty(anprSetting.notOnAllowListContraventionId) && getContraventionDisplayDetails(anprSetting.notOnAllowListContraventionId)}</div>
                            </div>
                        </div>
                    </>}

                    <hr className="border-dashed border-bottom-0"></hr>
                    <div className="row mb-2">
                        <div className="col-md-4 col-12">
                            <h5 className="font-weight-semi-bold mt-1 text-left">Short Return Contravention</h5>
                        </div>
                    </div>
                    <div className="row align-items-center mb-1">
                        <div className="col-md-4 col-12">
                            <p className="font-weight-semi-bold mb-1">Enabled</p>
                        </div>
                        <div className="col-md-6 col-12 ">
                            <i className={`fas ${!StringHelpers.isNullOrEmpty(anprSetting.shortReturnContraventionId) ? "fa-check text-success" : "fa-times text-danger"}`}></i>
                        </div>
                    </div>
                    {!stringHelpers.isNullOrEmpty(anprSetting.shortReturnContraventionId) && <>
                        <div className="row">
                            <div className=" col-md-4 col-12 ">
                                <p className="font-weight-semi-bold">Contravention</p>
                            </div>
                            <div className="col-md-6 col-12 ">
                                <div>{!StringHelpers.isNullOrEmpty(anprSetting.shortReturnContraventionId) && getContraventionDisplayDetails(anprSetting.shortReturnContraventionId)}</div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4 col-12">
                                <p className="font-weight-semi-bold">No Return Within (mins)</p>
                            </div>
                            <div className="col-md-6 col-12 ">
                                <div>{StringHelpers.formatDecimal(anprSetting.noReturnWithinMinutes, 0)}</div>
                            </div>
                        </div>
                        {isStandardAnpr && <div className="row">
                            <div className="col-md-4 col-12">
                                <p className="font-weight-semi-bold">Enforce Short Return for Allow List Entries</p>
                            </div>
                            <div className="col-md-6 col-12 ">
                                <i className={`fas ${anprSetting.enforceShortReturnForAllowListEntries ? "fa-check text-success" : "fa-times text-danger"}`}></i>
                            </div>
                        </div>}
                    </>}
                    {isStandardAnpr && <>
                        <hr className="border-dashed border-bottom-0"></hr>
                        <div className="row mb-2">
                            <div className="col-12">
                                <h5 className="font-weight-semi-bold mt-1 text-left">Overnight Stay Contravention</h5>
                            </div>
                        </div>
                        <div className="row align-items-center mb-1">
                            <div className=" col-md-4 col-12">
                                <p className="font-weight-semi-bold mb-1">Enabled</p>
                            </div>
                            <div className=" col-md-6 col-12 ">
                                {!StringHelpers.isNullOrEmpty(anprSetting.overnightStayContraventionId) &&
                                    <i className="fas fa-check text-success"></i>}
                                {StringHelpers.isNullOrEmpty(anprSetting.overnightStayContraventionId) &&
                                    <i className="fas fa-times text-danger"></i>}
                            </div>
                        </div>
                        {!StringHelpers.isNullOrEmpty(anprSetting.overnightStayContraventionId) && <>
                            <div className="row align-items-center mb-1">
                                <div className=" col-md-4 col-12 ">
                                    <p className="font-weight-semi-bold mb-1">Contravention</p>
                                </div>
                                <div className=" col-md-6 col-12 ">{getContraventionDisplayDetails(anprSetting.overnightStayContraventionId)}</div>
                            </div>
                            <div className="row align-items-center mb-1">
                                <div className=" col-md-4 col-12 ">
                                    <p className="font-weight-semi-bold mb-1">Time Range</p>
                                </div>
                                <div className=" col-md-6 col-12 ">
                                    {anprSetting.overnightStayStartTime?.substring(0, 5)} - {anprSetting.overnightStayEndTime?.substring(0, 5)}</div>
                            </div>
                            <div className="row align-items-center mb-1">
                                <div className=" col-md-4 col-12 ">
                                    <p className="font-weight-semi-bold mb-1">Grace Period (mins)</p>
                                </div>
                                <div
                                    className=" col-md-6 col-12 ">{StringHelpers.formatDecimal(anprSetting.overnightStayGraceMinutes, 0)}</div>
                            </div>
                        </>}

                    </>}
                    <hr className="border-dashed border-bottom-0"></hr>
                    <div className="row mb-2">
                        <div className="col-md-4 col-12">
                            <h5 className="font-weight-semi-bold mt-1 text-left">Pay and Display</h5>
                        </div>
                    </div>
                    <div className="row align-items-center mb-2">
                        <div className=" col-md-4 col-12 ">
                            <p className="font-weight-semi-bold mb-1">Enabled</p>
                        </div>
                        <div className="col-md-6 col-12 ">
                            <i className={`fas ${anprSetting.isPayAndDisplayEnabled ? "fa-check text-success" : "fa-times text-danger"}`}></i>
                        </div>
                    </div>
                    <div className="row">
                        <div className=" col-md-4 col-12 ">
                            <p className="font-weight-semi-bold">Free parking duration</p>
                        </div>
                    <div className=" col-md-6 col-12 ">
                        { StringHelpers.formatDecimal(minutesToUnit(anprSetting.freeParkingMinutes).value, 0) }
                        <span className="ml-1">
                            { StringHelpers.pluralSuffixModifier(minutesToUnit(anprSetting.freeParkingMinutes).value, Enums.TimeSpanMode[minutesToUnit(anprSetting.freeParkingMinutes).unit]) }</span>
                    </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4 col-12">
                            <p className="font-weight-semi-bold">Contravention for Failure to Make Payment</p>
                        </div>
                        <div className="col-md-6 col-12 ">
                            {getContraventionDisplayDetails(anprSetting.failedToMakePaymentContraventionId)}
                        </div>
                    </div>
                    <div className="row">
                        <div className=" col-md-4 col-12 ">
                            <p className="font-weight-semi-bold">Contravention for Overstayed Payment Period</p>
                        </div>
                        <div className=" col-md-6 col-12 ">
                            {getContraventionDisplayDetails(anprSetting.overstayedPaymentPeriodContraventionId)}
                        </div>
                    </div>
                </>
            }
        {!isStandardAnpr && <>
            <hr className="border-dashed border-bottom-0"></hr>
            <div className="row mb-2">
                <div className="col-md-4 col-12">
                    <h5 className="font-weight-semi-bold mt-1 text-left">Date/Time Details</h5>
                </div>
            </div>
            <div className="row">
                <div className="col-md-4 col-12 ">
                    <p className="font-weight-semi-bold  mb-3">Start Date</p>
                </div>
                <div className="col-md-6 col-12 ">{toDateTimeString(anprSetting.startDate)}</div>
            </div>
            <div className="row">
                <div className="col-md-4 col-12 ">
                    <p className="font-weight-semi-bold  mb-3">End Date</p>
                </div>
                <div className="col-md-6 col-12 ">{toDateTimeString(anprSetting.endDate)}</div>
            </div>
            <div className="row">
                <div className="col-md-4 col-12 ">
                    <p className="font-weight-semi-bold  mb-3">Valid only on specific days</p>
                </div>
                <div
                    className="col-md-6 col-12 ">{validityDays.find(item => item.isEnabled) !== undefined ? <>Yes</> : <>No</>}</div>
            </div>
            {validityDays.find(item => item.isEnabled) !== undefined && validityDays.map(day => <div className="row">
                <div className="col-md-4 col-12 ">
                    <p className="font-weight-semi-bold  mb-3">{day.label}</p>
                </div>
                <div className="col-md-6 col-12 ">{day.isEnabled ? <>Yes</> : <>No</>}</div>
            </div>)}
            <div className="row">
                <div className="col-md-4 col-12 ">
                    <p className="font-weight-semi-bold  mb-3">Valid only at specific times of the
                        day</p>
                </div>
                <div className="col-md-6 col-12 ">{noSpecificValidityTimes ? <>No</> : <>Yes</>}</div>
            </div>
            {!noSpecificValidityTimes &&
                <div className="row">
                <div className="col-md-4 col-12 ">
                    <p className="font-weight-semi-bold  mb-3">Time Range</p>
                </div>
                <div
                    className="col-md-6 col-12 ">{anprSetting.enabledFromTime?.slice(0, 5)} - {anprSetting.enabledToTime?.slice(0, 5)}
                </div>
            </div>}
        </>}
    </div>)
}